export default __webpack_public_path__ + "static/media/bothWeekends.ab01f608.png";